import { CSSObject } from '@emotion/react';

export const ButtonIncrease: CSSObject = {
  variant: 'odds',
  fontWeight: 'normal',
};

export const buttonIncreaseProps: CSSObject = {
  variant: 'odds',
  fontWeight: 'normal',
};
